import axios from 'axios';
import React from 'react';
import { useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { toast } from 'react-toastify';
import LoadingButton from '../../../../components/Shared/LoadingButton';
import auth from '../../../../firebase.init';

const AddDevice = ({ refetch }) => {
    const [user] = useAuthState(auth);
    const [deviceLoading, setDeviceLoading] = useState(false);

    const handleAddDevice = (e) => {
        e.preventDefault();
        setDeviceLoading(true);
        const deviceId = e.target.deviceId.value;
        const deviceName = e.target.deviceName.value;
        const deviceStatus = "Pending";
        const deviceOwner = user?.email;

        if (deviceOwner) {
            // Adding device 
            (async () => {
                const payload = { deviceId, deviceName, deviceStatus, deviceOwner }
                const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}api/v1/bms/user-devices`, payload);

                if (res.data.success) {
                    toast.success('Device Added Successfully', { position: "top-left" });
                    e.target.reset();
                    refetch();
                }
                setDeviceLoading(false);
            })();
        }
    }


    return (
        <div>
            <h3 className='text-lg font-medium border-b text-center pb-1 text-primary'>Add A New Device From Here</h3>
            <form onSubmit={(e) => { handleAddDevice(e) }} className='w-full'>
                <div className='my-3 relative'>
                    <input type="text" name='deviceId' required placeholder="Device ID" class="input input-bordered w-full" />
                    <span className='absolute right-2 top-3 text-red-500 font-bold text-xl'>*</span>
                </div>
                <div className='my-3'>
                    <input type="text" name='deviceName' placeholder="Device Name" class="input input-bordered w-full" />
                </div>
                {!deviceLoading ?
                    <button type='submit' className='btn btn-primary btn-md w-full'>Add New Device</button>
                    :
                    <LoadingButton name={"Adding"} />
                }
            </form>
        </div>
    );
};

export default AddDevice;